import { defineComponent as _defineComponent } from 'vue'
import C4EIcon from "@/components/commons/C4EIcon.vue";
import {useUserStore} from "@/store/user.store";
import {computed, onMounted, onUnmounted, ref} from "vue";
import CoinAmount from "@/components/commons/CoinAmount.vue";
import {BigDecimal} from "@/models/store/big.decimal";
import {BigIntWrapper, Coin, DecCoin} from "@/models/store/common";
import Dialog from "primevue/dialog";
import QrcodeVue from "qrcode.vue";
import {useToast} from "vue-toastification";
import i18n from "@/plugins/i18n";
import { Copy } from 'lucide-vue-next';
import dataService from "@/services/data.service";
import {Field} from "vee-validate";
import {useConfigurationStore} from "@/store/configuration.store";
import {calculatePrice} from "@/utils/token-price";
import {useTokensStore} from "@/store/tokens.store";
// import FormattedNumber from "@/components/commons/FormattedNumber.vue"; - future USD ratio

const freeMultiplier = 1.2;

export default /*#__PURE__*/_defineComponent({
  __name: 'PortfolioSummary',
  setup(__props, { expose: __expose }) {
  __expose();

const userStore = useUserStore();

const totalBalance = computed(()=> {
  return userStore.getBalance;
});

const enableButton = computed(()=> {
  return targetAddress.value && targetAddress.value.length==42;
});

const spendableBalance = computed(()=> {
  if (!userStore.getAccount.address) return 0n;
  return userStore.getSpendableBalance || 0n;
});

/*
Conversion to USD - change ratio return value to actual conversion ratio

const ratio = computed(()=> {
  return .....;
});

const amountToUSD = (amount: bigint) => {
  let converted = Number(String(amount)) / 1000000;
  if (ratio.value)
    return converted * ratio.value;
  else
    return converted * 0.085;
};

 */

function convertAmount( amount: bigint | number | BigDecimal | Coin | DecCoin){
  if( typeof amount === 'bigint'){
    return new BigIntWrapper(amount);
  } else {
    return amount;
  }
}

function copyTxt(){
  navigator.clipboard.writeText(userStore.getAccount.address);
  useToast().success(i18n.global.t('COPY.ADDRESS'));
}

const receiveDialogVisible = ref(false);
const sendDialogVisible = ref(false);

const targetAddress = ref('');
const amount = ref(0);

const usedGas = ref (0);
const fee = ref(0);



const handleSend = () => {
  useUserStore().sendTokens(targetAddress.value, amount.value, usedGas.value, onSuccessSend);
};

async function simulate(){
  const spendables = useUserStore().getSpendableBalance;
  if (targetAddress.value && spendables) {
    await useUserStore().simulateSending(targetAddress.value, Number(useConfigurationStore().config.getConvertedAmount(spendables))).then((res) => {
      console.log("predicted gas usage:" + res);
      usedGas.value = Number(Number(Number(res)  * freeMultiplier).toFixed(6));
      usedGas.value *= 1.1;
      console.log("predicted usedGas multiplied:" + usedGas.value);
      fee.value = Number((usedGas.value * useConfigurationStore().config.getGasPrise()).toFixed(6));
      console.log("fee:" + fee.value);
      amount.value = Number(useConfigurationStore().config.getConvertedAmount(spendables)) - fee.value/1000000;
      amount.value = Math.floor(amount.value * 1000000)/1000000;
    });
  } else {
    fee.value = 0;
  }
}

function onSuccessSend(){
  sendDialogVisible.value = false;
}


const __returned__ = { userStore, totalBalance, enableButton, spendableBalance, convertAmount, copyTxt, receiveDialogVisible, sendDialogVisible, targetAddress, amount, freeMultiplier, usedGas, fee, handleSend, simulate, onSuccessSend, C4EIcon, CoinAmount, get Dialog() { return Dialog }, QrcodeVue, get Copy() { return Copy }, get Field() { return Field }, get calculatePrice() { return calculatePrice }, get useTokensStore() { return useTokensStore } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})